import { ColumnDef } from "@tanstack/react-table";
import { DataTableColumnHeader } from "components/ui/DataTable";
import { DataTableActions, IDataTableAction } from "components/ui/DataTableActions";
import { Admin } from "contracts/Admins";
import { usePermission } from "hooks/usePermission";
import { format } from "path";
import { Formatter } from "utils";

export function useColumns(){

    const { hasPermissionTo } = usePermission()
    const columns: ColumnDef<Admin>[] = [
        {
            id: 'Id',
            accessorKey: 'id',
            header: ({column}) => (
                <DataTableColumnHeader column={column} title="Id" />
            ),
            cell: ({ row }) => {
                return `${row.original.id}`
            },
            enableSorting: true,
            enableHiding: true,
        },
         {
            id: 'Nome',
            accessorKey: 'user.name',
            header: ({column}) => (
                <DataTableColumnHeader column={column} title="Nome" />
            ),
            cell: ({ row }) => {
                return `${row.original.user.name ?? "---"}`
            },
            enableSorting: true,
            enableHiding: true,
        },
        {
            id: 'Email',
            accessorKey: 'email',
            header: ({column}) => (
                <DataTableColumnHeader column={column} title="Email" />
            ),
            cell: ({ row }) => {
                return `${row.original.user.email ?? "---"}`
            },
            enableSorting: true,
            enableHiding: true,
        },
        {
            id: 'LastAccess',
            accessorKey: 'lastAccess',
            header: ({column}) => (
                <DataTableColumnHeader column={column} title="Último Acesso" />
            ),
            cell: ({ row }) => {
                return `${Formatter.date(row.original.user?.loggedAt, { format: "dd/MM/yyyy 'as' HH:mm" }) ?? "--/--/----"}`
            },
            enableSorting: true,
            enableHiding: true,
        },
        {
            id: 'actions',
            cell: ({ row }) => {
                const actions: IDataTableAction[] = [
                   {
                        name: 'Editar',
                        route: `/configuracoes/usuarios/editar/${row.original.user.id}`,
                        hasPermission: hasPermissionTo(['ADMINS.UPDATEADMIN']),
                    },
                    // {
                    //     name: 'Logar como',
                    //     route: `/configuracoes/usuarios/impersonate/${row.original.user.email}`,
                    //     hasPermission: hasPermissionTo(['AUTH.IMPERSONATE'])
                    // }
                ];
                return <DataTableActions actions={actions} />;
            },
        },
    ]

    return { columns }
}